import { ObjectHelper } from 'Code/Helpers/ObjectHelper';
import { SystemService } from 'DataAccessLayer/Services/SystemService';
import { ItemGridColumns } from './ItemGridColumns';
import { ItemGridTaxSumItem } from './ItemGridTaxSumItem';
import { NumberHelper } from 'Code/Helpers/NumberHelper';
export class ItemGridUtil {
    public static Calc() {


    }

    public static async CalculationVatValidation(item: Object, schema: Object) {

        //if (ObjectHelper.IsNullOrUndefined(item[ItemGridColumns.Quantity]))
        //    return false;

        if (ObjectHelper.IsNullOrUndefined(item[ItemGridColumns.UnitPrice])) {
            return false;
        }

        return true;
    }

    public static async CalculatePricePohoda(item: Object, schema: Object, roundCoefficient: boolean) {
        let round: number = 2;

        if (
            item.hasOwnProperty(ItemGridColumns.UnitPrice) && ObjectHelper.IsNotNullAndUndefined(item[ItemGridColumns.UnitPrice])
        ) {
            let taxIncluded: boolean = false;
            if (item.hasOwnProperty(ItemGridColumns.TaxIncluded) && ObjectHelper.IsNotNullAndUndefined(item[ItemGridColumns.TaxIncluded])) {
                taxIncluded = item[ItemGridColumns.TaxIncluded];
            }
            let quantity: number = 1;
            if (item.hasOwnProperty(ItemGridColumns.Quantity) && ObjectHelper.IsNotNullAndUndefined(item[ItemGridColumns.Quantity])) {
                quantity = item[ItemGridColumns.Quantity];
            }
            let unitPrice: number = item[ItemGridColumns.UnitPrice];
            let taxValue: number = 0;
            if (item.hasOwnProperty(ItemGridColumns.TaxRate) && ObjectHelper.IsNotNullAndUndefined(item[ItemGridColumns.TaxRate])) {
                let taxRate_FK: number = item[ItemGridColumns.TaxRate];
                if (taxRate_FK > 0) {
                    let taxID = await SystemService.Instance.GetEntityEnumerationById('Tax', taxRate_FK);
                    if (ObjectHelper.IsNotNullAndUndefined(taxID)) {
                        taxValue = Number(Number.parseFloat(taxID['Value']).toFixed(5));
                    }
                }
            }
            let coefficient: number = roundCoefficient ? NumberHelper.Round(taxValue / (1 + taxValue), 4) : (taxValue / (1 + taxValue));
            //console.log(222, taxIncluded, taxValue, quantity, unitPrice);

            let total_WithoutTax_WithoutDiscounts: number = 0;
            let total_Tax_WithoutDiscounts: number = 0;
            let total_WithoutDiscounts: number = 0;

            if (!taxIncluded) {
                total_WithoutTax_WithoutDiscounts = NumberHelper.Round(quantity * unitPrice, round);
                
                total_WithoutDiscounts = NumberHelper.Round(total_WithoutTax_WithoutDiscounts * (taxValue + 1), round);
                total_Tax_WithoutDiscounts = NumberHelper.Round((total_WithoutDiscounts - total_WithoutTax_WithoutDiscounts), round);
            }
            else {
                total_WithoutDiscounts = NumberHelper.Round(quantity * unitPrice, round);
                total_Tax_WithoutDiscounts = NumberHelper.Round(total_WithoutDiscounts * coefficient, round);
                total_WithoutTax_WithoutDiscounts = NumberHelper.Round((total_WithoutDiscounts - total_Tax_WithoutDiscounts), round);
            }


            item[ItemGridColumns.TotalWithoutTax_WithoutDiscounts] = total_WithoutTax_WithoutDiscounts;
            item[ItemGridColumns.TotalTax_WithoutDiscounts] = total_Tax_WithoutDiscounts;
            item[ItemGridColumns.Total_WithoutDiscounts] = total_WithoutDiscounts;


            let total_WithoutTax_WithDiscounts: number = total_WithoutTax_WithoutDiscounts;
            let total_Tax_WithDiscounts: number = total_Tax_WithoutDiscounts;
            let total_WithDiscounts: number = total_WithoutDiscounts;

            if (item.hasOwnProperty(ItemGridColumns.UnitPriceDiscount) && ObjectHelper.IsNotNullAndUndefined(item[ItemGridColumns.UnitPriceDiscount])) {
                let discount = item[ItemGridColumns.UnitPriceDiscount];
                if (Math.abs(discount) > 0) {

                    if (ObjectHelper.IsNotNullAndUndefined(discount) && Math.abs(Number(discount)) > 0) { // discount is numeric withou percentage
                        if (!taxIncluded) {
                            total_WithDiscounts = NumberHelper.Round(quantity * (unitPrice - discount) * (taxValue + 1), round);
                            total_Tax_WithDiscounts = total_WithDiscounts - NumberHelper.Round(quantity * (unitPrice - discount), round);
                            total_WithoutTax_WithDiscounts = NumberHelper.Round((total_WithDiscounts - total_Tax_WithDiscounts), round);
                        }
                        else {
                            total_WithDiscounts = NumberHelper.Round(quantity * (unitPrice - discount), round);
                            total_Tax_WithDiscounts = NumberHelper.Round(total_WithDiscounts * coefficient, round);
                            total_WithoutTax_WithDiscounts = NumberHelper.Round((total_WithDiscounts - total_Tax_WithDiscounts), round);
                        }
                    }
                }
            }

            if (item.hasOwnProperty(ItemGridColumns.UnitPriceDiscountPercentage) && ObjectHelper.IsNotNullAndUndefined(item[ItemGridColumns.UnitPriceDiscountPercentage])) {
                let discount: number = item[ItemGridColumns.UnitPriceDiscountPercentage];
                if (Math.abs(discount) > 0) {
                    let discountPercValue: number = discount / 100;
                    if (!taxIncluded) {
                        total_WithoutTax_WithDiscounts = NumberHelper.Round(total_WithoutTax_WithDiscounts * (1 - discountPercValue), round);
                        total_WithDiscounts = NumberHelper.Round(total_WithoutTax_WithDiscounts * (taxValue + 1), round);
                        total_Tax_WithDiscounts = NumberHelper.Round((total_WithDiscounts - total_WithoutTax_WithDiscounts), round);
                    }
                    else {
                        total_WithDiscounts = NumberHelper.Round(total_WithDiscounts * (1 - discountPercValue), round);
                        total_Tax_WithDiscounts = NumberHelper.Round(total_WithDiscounts * coefficient, round);
                        total_WithoutTax_WithDiscounts = NumberHelper.Round((total_WithDiscounts - total_Tax_WithDiscounts), round);
                    }
                }
            }

            item[ItemGridColumns.TotalWithoutTax_WithDiscount] = total_WithoutTax_WithDiscounts;
            item[ItemGridColumns.TotalTax_WithDiscounts] = total_Tax_WithDiscounts;
            item[ItemGridColumns.Total_WithDiscounts] = total_WithDiscounts;
        }
        else {
            item[ItemGridColumns.TotalWithoutTax_WithoutDiscounts] = 0;
            item[ItemGridColumns.TotalTax_WithoutDiscounts] = 0;
            item[ItemGridColumns.Total_WithoutDiscounts] = 0;

            item[ItemGridColumns.TotalWithoutTax_WithDiscount] = 0;
            item[ItemGridColumns.TotalTax_WithDiscounts] = 0;
            item[ItemGridColumns.Total_WithDiscounts] = 0;
        }
    }

    public static async CalculateMarginAndAddition(item: Object, schema: Object) {
        let round: number = 2;
        let roundCoef: number = Math.pow(10, round);

        if (item.hasOwnProperty(ItemGridColumns.CostPrice) && ObjectHelper.IsNotNullAndUndefined(item[ItemGridColumns.CostPrice])
            && item.hasOwnProperty(ItemGridColumns.UnitPrice) && ObjectHelper.IsNotNullAndUndefined(item[ItemGridColumns.UnitPrice])
        ) {
            let quantity: number = 1;
            if (item.hasOwnProperty(ItemGridColumns.Quantity) && ObjectHelper.IsNotNullAndUndefined(item[ItemGridColumns.Quantity])) {
                quantity = item[ItemGridColumns.Quantity];
            }
            if (quantity == 0){
                quantity = 1;
            }
            let unitPrice: number = item[ItemGridColumns.UnitPrice];
            let unitPriceTotal: number = unitPrice * quantity;
            let costPriceTotal: number = item[ItemGridColumns.CostPrice] * quantity;

            if (item.hasOwnProperty(ItemGridColumns.UnitPriceDiscount) && ObjectHelper.IsNotNullAndUndefined(item[ItemGridColumns.UnitPriceDiscount])) {
                let discount = item[ItemGridColumns.UnitPriceDiscount];
                if (Math.abs(discount) > 0) {

                    if (ObjectHelper.IsNotNullAndUndefined(discount) && Math.abs(Number(discount)) > 0) { // discount is numeric withou percentage
                        unitPriceTotal = quantity * (unitPrice - discount);
                    }
                }
            }

            if (item.hasOwnProperty(ItemGridColumns.UnitPriceDiscountPercentage) && ObjectHelper.IsNotNullAndUndefined(item[ItemGridColumns.UnitPriceDiscountPercentage])) {
                let discount: number = item[ItemGridColumns.UnitPriceDiscountPercentage];
                if (Math.abs(discount) > 0) {
                    let discountPercValue: number = discount / 100;
                    unitPriceTotal = unitPriceTotal * (1 - discountPercValue);
                }
            }

            let total_Addition: number = costPriceTotal != 0 ? (NumberHelper.Round((unitPriceTotal - costPriceTotal) / costPriceTotal * 100, round)) : 0;
            let total_Margin: number = unitPriceTotal != 0 ? (NumberHelper.Round((unitPriceTotal - costPriceTotal) / unitPriceTotal * 100, round)) : 0;

            item[ItemGridColumns.Total_Addition] = total_Addition;
            item[ItemGridColumns.Total_Margin] = total_Margin;
        }
    }

    public static async CalculateUnitPriceAndAddition(item: Object, schema: Object) {
        let round: number = 2;
        let roundCoef: number = Math.pow(10, round);

        if (item.hasOwnProperty(ItemGridColumns.CostPrice) && ObjectHelper.IsNotNullAndUndefined(item[ItemGridColumns.CostPrice])
            && item.hasOwnProperty(ItemGridColumns.Total_Margin) && ObjectHelper.IsNotNullAndUndefined(item[ItemGridColumns.Total_Margin])
        ) {
            let quantity: number = 1;
            if (item.hasOwnProperty(ItemGridColumns.Quantity) && ObjectHelper.IsNotNullAndUndefined(item[ItemGridColumns.Quantity])) {
                quantity = item[ItemGridColumns.Quantity];
            }
            if (quantity == 0){
                quantity = 1;
            }
            let costPriceTotal: number = item[ItemGridColumns.CostPrice] * quantity;
            let margin: number = item[ItemGridColumns.Total_Margin];

            if (margin < 100 && quantity > 0) {
                let unitPriceTotal: number = (-100 * costPriceTotal) / (margin - 100)
                let unitPrice: number = unitPriceTotal / quantity;
                let total_Addition: number = costPriceTotal != 0 ? (NumberHelper.Round((unitPriceTotal - costPriceTotal) / costPriceTotal * 100, round)) : 0;

                item[ItemGridColumns.UnitPrice] = unitPrice;
                item[ItemGridColumns.Total_Addition] = total_Addition;
            }
        }
    }

    public static async CalculateUnitPriceAndMargin(item: Object, schema: Object) {
        let round: number = 2;
        let roundCoef: number = Math.pow(10, round);
        if (item.hasOwnProperty(ItemGridColumns.CostPrice) && ObjectHelper.IsNotNullAndUndefined(item[ItemGridColumns.CostPrice])
            && item.hasOwnProperty(ItemGridColumns.Total_Addition) && ObjectHelper.IsNotNullAndUndefined(item[ItemGridColumns.Total_Addition])
        ) {
            let quantity: number = 1;
            if (item.hasOwnProperty(ItemGridColumns.Quantity) && ObjectHelper.IsNotNullAndUndefined(item[ItemGridColumns.Quantity])) {
                quantity = item[ItemGridColumns.Quantity];
            }
            if (quantity == 0){
                quantity = 1;
            }
            let costPriceTotal: number = item[ItemGridColumns.CostPrice] * quantity;
            let addition: number = item[ItemGridColumns.Total_Addition];

            if (quantity > 0) {
                let unitPriceTotal: number = costPriceTotal * (addition + 100) / 100;
                let unitPrice: number = unitPriceTotal / quantity;
                let total_Margin: number = unitPriceTotal != 0 ? (NumberHelper.Round((unitPriceTotal - costPriceTotal) / unitPriceTotal * 100, round)) : 0;

                item[ItemGridColumns.UnitPrice] = unitPrice;
                item[ItemGridColumns.Total_Margin] = total_Margin;
            }
        }
    }
}